import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from 'src/pages/MiniApps/MiniApps.module.scss';

interface MiniAppAccessButtonProps {
  url: string;
  text: string;
}

const MiniAppAccessButton: React.FC<MiniAppAccessButtonProps> = ({
  url,
  text,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <Button
        variant='contained'
        className={styles.miniAppsPageButton}
        onClick={() => {
          navigate(url);
        }}
      >
        {text}
      </Button>
    </>
  );
};

const MiniAppNavigation: React.FC = () => {
  return (
    <div className={styles.miniAppsPageButtonContainer}>
      <MiniAppAccessButton
        url='/mini-apps/receipt-splitter'
        text='Receipt Splitter'
      />
      {/* 
      make a page to help you calculate betting arbitrage
      https://m.youtube.com/watch?v=2kDTwP6SBx4
      https://m.youtube.com/watch?v=s6R9xB1RdZU
      https://m.youtube.com/watch?v=4dS77MY9wUU
      */}
      {/* create a compound interest calculator. 
      add a graph that shows the portion of the bar each year that is interest vs principle */}
    </div>
  );
};

const MiniApps: React.FC = () => {
  return (
    <Box sx={{ minHeight: '67vh', padding: '32px' }}>
      <Typography
        variant='h6'
        sx={{ display: 'flex', justifyContent: 'center' }}
      >
        Mini Apps
      </Typography>
      <MiniAppNavigation />
    </Box>
  );
};

export default MiniApps;
